module.exports = __webpack_public_path__ + "static/media/lighthouse-circle.e0b82d14.png";